import React from "react";
import multilingualismImg from "../../../images/services-img/Multilingualism.png";

const MultilingualIllustration = ({
  altText = "NKENNEAi Multilingual Professional Language Services",
}) => {
  return (
    <div
      className="mt-10 sm:mt-12 lg:mt-14 w-full max-w-6xl xl:max-w-7xl flex justify-center"
      data-aos="fade-up"
      data-aos-delay="150"
    >
      <img
        src={multilingualismImg}
        alt={altText}
        className="w-full max-w-5xl xl:max-w-6xl h-auto object-contain select-none pointer-events-none"
        loading="eager"
      />
    </div>
  );
};

export default MultilingualIllustration;
